"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _expoApp = require("./expo-app");

var _LiveWidget = require("./expo-app/LiveWidget");

var _ModalTakeoverWidget = require("./ModalTakeoverWidget");

var _dialogs = require("./dialogs");

var _timeTrack = require("./time-track");

var _timeProvider = require("./time-provider");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var eventsBus = window.eventsBus;
var content = eventsBus.getContent();
(0, _timeProvider.setGlobals)(_objectSpread(_objectSpread({}, content.eventInfo), {}, {
  reactLayerConfig: content.reactLayerConfig
}));

var initApp = function initApp() {
  (0, _expoApp.initExpoApp)(eventsBus);
  (0, _dialogs.initDialogs)(eventsBus);
  (0, _timeTrack.initTimeTrack)(eventsBus);
  (0, _LiveWidget.initExpoLiveWidget)(eventsBus);
  (0, _ModalTakeoverWidget.initModalTakeoverWidget)(eventsBus);
};

var _default = initApp;
exports.default = _default;